<template>
    <div>
        <!-- Footer -->
        <footer class="footer">
            <!-- Top Footer -->
            <router-link to="/" class="footer-brand mobile-hide"><img src="/static/images/logo.png" alt="brand"></router-link>
            <div class="top-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
<!--                                <div class="col-md-4">-->
                                    <!--                                    <h5 v-if="lang === 'ar'">خدمة العملاء</h5>-->
                                    <!--                                    <h5 v-else>Customer Service</h5>-->
                                    <!--                                    <ul>-->
                                    <!--                                        <li v-if="lang === 'ar'"><router-link to="#">الخدمة والضمان</router-link></li>-->
                                    <!--                                        <li v-else><router-link to="#">Service & Warranty</router-link></li>-->
                                    <!--                                        <li v-if="lang === 'ar'"><router-link to="#">إرجاع و إستبدال</router-link></li>-->
                                    <!--                                        <li v-else><router-link to="#">Return & Exchange</router-link></li>-->
                                    <!--                                        <li v-if="lang === 'ar'"><router-link to="#">المدفوعات عبر الإنترنت</router-link></li>-->
                                    <!--                                        <li v-else><router-link to="#">Secured Online Payments</router-link></li>-->
                                    <!--                                        <li v-if="lang === 'ar'"><router-link to="#">الدفع عن الاستلام</router-link></li>-->
                                    <!--                                        <li v-else><router-link to="#">Cash on Delivery</router-link></li>-->
                                    <!--                                        <li v-if="lang === 'ar'"><router-link to="#">الشحن و التسليم</router-link></li>-->
                                    <!--                                        <li v-else><router-link to="#">Shipping & Delivery</router-link></li>-->
                                    <!--                                    </ul>-->
<!--                                </div>-->
                                <div class="col-md-6">
                                    <h5 v-if="lang === 'ar'">معلومات عنا</h5>
                                    <h5 v-else>About Us</h5>
                                    <ul>
                                        <li v-if="lang === 'ar'"><a href="http://www.universalcsc.com/About.aspx">معلومات عنا</a></li>
                                        <li v-else><a href="http://www.universalcsc.com/ar/About.aspx">About Us</a></li>
                                        <li v-if="lang === 'ar'"><a href="http://www.universalcsc.com/ar/Branches.aspx">فروعنا</a></li>
                                        <li v-else><a href="http://www.universalcsc.com/Branches.aspx">Our Branches</a></li>
                                        <li v-if="lang === 'ar'"><a href="http://www.universalcsc.com/ar/Career.aspx">وظائف</a></li>
                                        <li v-else><a href="http://www.universalcsc.com/Career.aspx">Careers</a></li>
<!--                                        <li v-if="lang === 'ar'"><a href="#">بيع معنا</a></li>-->
<!--                                        <li v-else><a href="#">Sell With Us</a></li>-->
                                        <li v-if="lang === 'ar'"><a href="http://www.universalcsc.com/ar/PrimeProducts.aspx">علاماتنا التجارية</a></li>
                                        <li v-else><a href="http://www.universalcsc.com/PrimeProducts.aspx">Our Brands</a></li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <h5 v-if="lang === 'ar'" style="font-size: 17px;">سنساعدك على توفير مالك</h5>
                                    <h5 v-else>Helping You Save</h5>
                                    <ul>
                                        <li v-if="lang === 'ar'"><router-link to="/waffir">برنامج بطاقة الولاء</router-link></li>
                                        <li v-else><router-link to="/waffir">Loyalty Card Program</router-link></li>
                                        <li v-if="lang === 'ar'"><router-link to="/register">سجل بطاقتك</router-link></li>
                                        <li v-else><router-link to="/register">Register Your Card</router-link></li>
                                        <li v-if="lang === 'ar'"><router-link to="/dashboard">لوحة التحكم بالنقاط</router-link></li>
                                        <li v-else><router-link to="/dashboard">Rewards Control Panel</router-link></li>
                                        <li v-if="lang === 'ar'"><router-link to="/terms">البنود و الشروط</router-link></li>
                                        <li v-else><router-link to="/terms">Loyalty Terms & Policies</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-6">
                                    <h5 v-if="lang === 'ar'">دعم العملاء</h5>
                                    <h5 v-else>Customer Support</h5>
                                    <ul>
                                        <li v-if="lang === 'ar'"><a href="http://www.universalcsc.com/ar/Contact.aspx">اتصل بنا</a></li>
                                        <li v-else><a href="http://www.universalcsc.com/Contact.aspx">Contact Us</a></li>

<!--                                        <li v-if="lang === 'ar'"><router-link to="#">سياسة خاصة</router-link></li>-->
<!--                                        <li v-else><router-link to="#">Privacy Policy</router-link></li>-->
<!--                                        <li v-if="lang === 'ar'"><router-link to="#">تحتاج مساعدة؟</router-link></li>-->
<!--                                        <li v-else><router-link to="#">Need Help?</router-link></li>-->
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <div class="call-box">
                                        <h5 v-if="lang === 'ar'"> تحتاج مساعدة؟</h5>
                                        <h5 v-else> Need Help?</h5>
                                        <p v-if="lang === 'ar'">
                                            <span v-if="countryMain === 1">+966 9200 00021</span>
                                            <span v-if="countryMain === 19">+973 3610 3031</span>
                                        </p>
                                        <p v-else>
                                            <span v-if="countryMain === 1">Call us on +966 9200 00021</span>
                                            <span v-if="countryMain === 19">Call us on +973 3610 3031</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- News Letter -->
            <div class="newsletter">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12"  v-bind:class="{'rtlx': rtl}">
                            <h1 v-if="lang === 'ar'">اشترك لأحدث العروض</h1>
                            <h1 v-else>Newsletter</h1>
<!--                            <p v-if="lang === 'ar'">الحصول على خصومات وعروض خاصة</p>-->
<!--                            <p v-else>Get Discount and Special Offers</p>-->
                            <form>
                                <input v-if="lang === 'ar'" class="form-control" type="email" placeholder="عنوان بريدك الإلكتروني">
                                <input v-else class="form-control" type="email" placeholder="Your email Address">
                                <button v-if="lang === 'ar'" type="submit"> <i class="fas fa-envelope"></i> الاشتراك</button>
                                <button v-else type="submit"> <i class="fas fa-envelope"></i> Subscribe</button>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <div class="copy-footer">
                <div class="container">
                    <div class="row">
                        <div v-if="countryMain === 1" class="col-md-4">
                            <ul class="social">
                                <li style="background-color: #3b5999"><a href=https://www.facebook.com/prime.supermarketksa><i class="fab fa-facebook-f"></i></a></li>
                                <li style="background-color: #55acee"><a href=https://twitter.com/alnokhbamarkets><i class="fab fa-twitter"></i></a></li>
                                <li style="background-color: #f57d00"><a href=https://www.instagram.com/alnokhbamarkets/><i class="fas fa-instagram"></i></a></li>
                                <li style="background-color: #bd081c"><a href=https://www.snapchat.com/add/primemarketksa1><i class="fab fa-snapchat"></i></a></li>
<!--                                <li style="background-color: #0077B5"><a href=#><i class="fab fa-linkedin-in"></i></a></li>-->
<!--                                <li style="background-color: #cd201f"><a href=#><i class="fab fa-youtube"></i></a></li>-->
                            </ul>
                        </div>
                        <div v-if="countryMain === 19" class="col-md-4">
                            <ul class="social">
                                <li style="background-color: #3b5999"><a href=" https://www.facebook.com/pages/category/Supermarket/Prime-Market-Bahrain-101385497949106"><i class="fab fa-facebook-f"></i></a></li>
                                <li style="background-color: #55acee"><a href="https://twitter.com/primemallmarket"><i class="fab fa-twitter"></i></a></li>
                                <li style="background-color: #f57d00"><a href="https://www.instagram.com/primemallmarket"><i class="fas fa-instagram"></i></a></li>
                                <li style="background-color: #bd081c"><a href="https://www.snapchat.com/add/ALNOKHBA_BH"><i class="fab fa-snapchat"></i></a></li>
                                <!--                                <li style="background-color: #0077B5"><a href=#><i class="fab fa-linkedin-in"></i></a></li>-->
                                <!--                                <li style="background-color: #cd201f"><a href=#><i class="fab fa-youtube"></i></a></li>-->
                            </ul>
                        </div>
                        <div class="col-md-4">
                            <p>&copy; 2019 &nbsp; <a href="http://www.gskills.com.sa">Gulf Skills IT</a> &nbsp; All Right Reserved. </p>
                        </div>
                        <div class="col-md-4">
<!--                            <ul class="payment">-->
<!--                                <li><router-link to=#><i class="fab fa-cc-paypal"></i></router-link></li>-->
<!--                                <li><router-link to=#><i class="fab fa-cc-amex"></i></router-link></li>-->
<!--                                <li><router-link to=#><i class="fab fa-cc-visa"></i></router-link></li>-->
<!--                                <li><router-link to=#><i class="fab fa-cc-mastercard"></i></router-link></li>-->
<!--                            </ul>-->
                        </div>
                    </div>
                </div>

            </div>
        </footer>

    </div>
</template>

<script>
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        // data () {
        //     return {
        //         //
        //     }
        // },
        computed: {
            auth () {
                return this.$store.getters['auth/isAuthenticated']
            },
            balance () {
                return this.$store.getters['account/getBalance']
            },
            countryMain(){
                return this.$store.getters['environment/getCountryMain']
            },
        },
        methods: {
            onLogout() {
                this.$store.dispatch('auth/logout')
            }
        }
    }
</script>
<style>
    /*@import url("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css");*/
</style>


// WEBPACK FOOTER //
// src/components/layout/footer.vue